import React, { useEffect, useState } from "react";
import CommentItem from "./CommentItem";
import CommentForm from "./CommentForm";
import "../../utils/echo";

const ChatBox = ({ taskId }) => {
  const [comments, setComments] = useState([]);
  const authToken = localStorage.getItem("auth_token");
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    const init = async () => {
      if (!authToken) return;

      try {
        const res = await fetch("https://loopsneller.com/api/user", {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const data = await res.json();
        setCurrentUserId(data.id);

        console.log("Subscribing to channel:", `task.${taskId}`);

        // Fetch comments once user is known
        await fetchComments();

        const channel = window.Echo.private(`task.${taskId}`);

        // Handle new comments
        channel.listen(".TaskCommented", (e) => {
          console.log("Real-time comment received:", e.comment);
          setComments((prev) => {
            const exists = prev.some((c) => c.id === e.comment.id);
            if (exists) return prev;
            return [...prev, e.comment];
          });
        });

        //Handle Comment updates
        channel.listen(".TaskCommentUpdated", (e) => {
          console.log("Real-time comment updated:", e.comment);
          setComments((prev) =>
            prev.map((c) => (c.id === e.comment.id ? e.comment : c))
          );
        });

        // Handle deleted comments
        channel.listen(".TaskCommentDeleted", (e) => {
          console.log("Real-time comment deleted:", e.comment_id);
          setComments((prev) =>
            prev.filter((comment) => comment.id !== e.comment_id)
          );
        });
      } catch (err) {
        console.error("Initialization error:", err);
      }
    };

    init();

    return () => {
      window.Echo.leave(`private-task.${taskId}`);
    };
  }, [authToken, taskId]);

  // Fetch comments from API
  const fetchComments = async () => {
    try {
      const res = await fetch(
        `https://loopsneller.com/api/tasks/${taskId}/comments`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      const data = await res.json();
      setComments(data);
    } catch (err) {
      console.error("Error loading comments:", err);
    }
  };

  const handleNewComment = () => {
    fetchComments();
  };

  return (
    <div className="card mt-4 shadow-sm rounded">
      <div className="card-header bg-primary text-white">Task Discussion</div>
      <div
        className="card-body"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        {comments.length === 0 && (
          <p className="text-muted">No comments yet.</p>
        )}
        {comments.map((comment) => (
          <CommentItem
            key={comment.id}
            comment={comment}
            taskId={taskId}
            onUpdate={fetchComments}
            currentUserId={currentUserId}
          />
        ))}
      </div>
      <div className="card-footer">
        <CommentForm taskId={taskId} onSuccess={handleNewComment} />
      </div>
    </div>
  );
};

export default ChatBox;
